module.exports = __webpack_public_path__ + "img/overview6.eb714e83.png";